module.exports = __webpack_public_path__ + "media/images/header-15a71520443685e941748c25821f7502.jpg";